//@flow

// ----------------------------------------
// Flights
// ----------------------------------------

export const STORE_FLIGHTS_IN_FLIGHTS: string = '[flight] store flights';
export const STORE_COUNTRIES: string = '[flight] store countries';
export const FLIGHT_BOOKING_SUCCESS =
  '[ flights analytics] FLIGHT_BOOKING_SUCCESS';
export const STORE_ALTERNATIVE_FLIGHTS: string = '[flights] store alternative flight search results';

// ----------------------------------------
// Authorization
// ----------------------------------------

export const LOGOUT: string = '[auth] logout';
export const REQUEST_LOGIN: string = '[auth] login';
export const STORE_TOKEN: string = '[auth] store_token';
export const REGISTER_ACCOUNT: string = '[auth] register';
export const INIT_USER_INFO: string = '[auth] init_user_info';
export const CLEAR_ALL_ERRORS: string = '[auth] clear_errors';
export const STORE_ERROR: string = '[auth] report_server_errors';
export const STORE_USER_INFORMATION: string = '[auth] save_user_info';
export const LOGIN_SESSION_EXPIRE: string = '[auth] expire_login_session';
export const RESET_USER_DATA: string = '[auth] clear_user_data';
export const SIGNEDUP_SUCCESS: string =
  '[auth] sending data to google analytics';

export const OPEN_LOGIN_MODAL: string = '[auth] open_login_modal';
export const OPEN_SIGNUP_MODAL: string = '[auth] open_signup_modal';
export const CLOSE_LOGIN_MODAL: string = '[auth] close_login_modal';

// ----------------------------------------
// INVOICES
// ----------------------------------------

export const STORE_INVOICES = '[profile] STORE_INVOICES';

// ----------------------------------------
// TREK OVERVIEW
// ----------------------------------------

export const OPEN_OVERVIEW_MODAL: string = '[overview] OPEN_OVERVIEW_MODAL';
export const OPEN_NESTED_OVERVIEW_MODAL: string =
  '[overview] OPEN_NESTED_OVERVIEW_MODAL';
export const CLOSE_NESTED_OVERVIEW_MODAL: string =
  '[overview] CLOSE_NESTED_OVERVIEW_MODAL';
export const CLOSE_OVERVIEW_MODAL: string = '[overview] CLOSE_OVERVIEW_MODAL';
export const UPDATE_OVERVIEW_EDITS: string =
  '[selectedTrek] UPDATE_OVERVIEW_EDITS';
export const STORE_TREK_PREFERENCES: string =
  '[trek overview] STORE_TREK_PREFERENCES';
export const USE_TREK_AS_TEMPLATE_SUCCESS: string =
  '[selectedTrek] USE_TREK_AS_TEMPLATE_SUCCESS';
export const STORE_NO_FLIGHTS: string = '[ trekPayment] store when no flights';
export const RESET_SELECTED_TREK = '[Selected Trek] RESET_SELECTED_TREK';
export const STORE_CHILD_TREKS = '[ selected trek ] store child treks';

// ----------------------------------------
// TREK OVERVIEW EDITOR
// ----------------------------------------

export const SET_ACTIVE_EDITOR: string = '[overview] SET_ACTIVE_EDITOR';
export const TOGGLE_EDITOR: string = '[editor] TOGGLE_EDITOR';
export const ACTIVATE_A_EDITOR: string = '[editor] ACTIVATE_A_EDITOR';
export const SET_EDITOR_TYPE: string = '[editor] SET_EDITOR_TYPE';
export const CLOSE_EDITOR: string = '[overview] CLOSE_EDITOR';

// ----------------------------------------
// SERVICES
// ----------------------------------------

export const OPEN_SERVICES_MODAL: string = 'OPEN_SERVICES_MODAL';
export const CLOSE_SERVICES_MODAL: string = 'CLOSE_SERVICES_MODAL';
export const SET_MODAL_CONFIG: string = 'SET_MODAL_CONFIG';
export const CLEAR_MODAL_CONFIG: string = 'CLEAR_MODAL_CONFIG';
export const CHANGE_MODAL_CONFIG: string = 'CHANGE_MODAL_CONFIG';
export const SET_CARD_LOADING_STATE: string = 'SET_CARD_LOADING_STATE';
export const OPEN_DAY_EDIT_NOTIFICATION_MODAL: string =
  'OPEN_DAY_EDIT_NOTIFICATION_MODAL';
export const CLOSE_DAY_EDIT_NOTIFICATION_MODAL: string =
  'CLOSE_DAY_EDIT_NOTIFICATION_MODAL';
export const SET_NOTIFICATION_TYPE: string = 'SET_NOTIFICATION_TYPE';

// ----------------------------------------
// SCHEMAS
// ----------------------------------------

export const SCHEMA_INIT: string = '[schema] init';
export const SCHEMA_ADD: string = '[schema] add';
export const SCHEMA_REMOVE: string = '[schema] remove';
export const SCHEMA_UPDATE: string = '[schema] update';
export const SCHEMA_ADD_BATCH: string = '[schema] add batch';
export const SCHEMA_ADD_LISTING: string = '[schema] add listing';
export const SCHEMA_REMOVE_BATCH: string = '[schema] remove batch';
export const SCHEMA_ADD_PLACE_LISTINGS: string =
  '[schema] add places in placelistings';
export const SCHEMA_REMOVE_PLACES_THEMES: string =
  '[schema] remove batch places';

// ----------------------------------------
// SELECTED TREK
// ----------------------------------------

export const STORE_SELECTED_TREK: string = '[selectedTrek] STORE_SELECTED_TREK';

// ----------------------------------------
// PLACES DETAILS
// ----------------------------------------

export const SET_SELECTED_PLACE_ID: string =
  '[selectedPlace] SET_SELECTED_PLACE_ID';
export const TOGGLE_PLACES_MODAL: string = '[ placesModal TOGGLE_PLACES_MODAL]';
export const OPEN_PLACES_MODAL: string = '[placesModal] OPEN_PLACES_MODAL';
export const CLOSE_PLACES_MODAL: string = '[placesModal] CLOSE_PLACES_MODAL';
export const CHANGE_SLIDE: string = '[placesModal] CHANGE_SLIDE';
export const SET_SORT_METHOD: string = '[ selectedPlace ] SET_SORT_METHOD';
export const SET_LIMIT_AND_PAGE: string = '[selectedPlace] SET_LIMIT_AND_PAGE';
export const SET_THEME_CATEGORIES: string =
  '[selectedPlace] SET_THEME_CATEGORIES';
export const SET_LAST_PAGE: string = '[selectedPlace] SET_LAST_PAGE';
export const CLEAR_THEME_CONFIGS: string =
  '[selectedPlace] CLEAR_THEME_CONFIGS';
export const FILTER_CARD_BY_SEARCH_TERM: string = 'FILTER_CARD_BY_SEARCH_TERM';

//EDIT MODAL
export const OPEN_MODAL: string = '[modal] open_modal';
export const CLOSE_MODAL: string = '[modal] close_modal';

// ----------------------------------------
// Trek Payment Review
// ----------------------------------------

export const STORE_TREK_PAYMENT_DETAILS: string =
  '[trekPayment] STORE_TREK_PAYMENT_DETAILS';
export const CHANGE_TREK_PAYMENT_TYPE: string =
  '[trekPayment] CHANGE_TREK_PAYMENT_TYPE';
export const TREK_PAYMENT_SUCCESS: string =
  '[trekPayment] TREK_PAYMENT_SUCCESS';
export const CHANGE_TREK_TEMPLATE_START_DATE =
  '[trekPayment] CHANGE_TREK_TEMPLATE_START_DATE';
export const TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW =
  '[ trekPayment analytics ] TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW';
export const PROCEED_TO_TREK_PAYMENT =
  '[trekPayment] get invoice for lodges in the trek and redirect to trek paymnent';
export const CHANGE_TREK_PAYMENT_NUMBER_OF_PEOPLE =
  '[trekPayment] CHANGE_TREK_PAYMENT_NUMBER_OF_PEOPLE';
export const SEARCH_FLIGHTS_IN_SELF_GUIDED_TREKS =
  '[ trekPayment] search flights';
export const STORE_FLIGHTS_FOR_SELF_GUIDED_TREKS =
  ' [ trekPayment ] store flights';
export const UPDATE_NUMBER_OF_PORTER: string =
  ' [trekPayment] update number of porter';
export const SELECT_GUIDE_TYPE: string = '[trekPayment] choose guide type';
export const LOADING_STATE_FOR_TREK_REVIEW: string =
  '[trekPayment] loading for reveiw';

// ----------------------------------------
// Lodges Payment Review
// ----------------------------------------
export const LODGE_BOOKING_REQUEST_SUCCESS: string =
  '[lodge] LODGE_BOOKING_REQUEST_SUCCESS';

// ----------------------------------------
// LIGHTBOX STATE
// ----------------------------------------
export const OPEN_LIGHTBOX: string = '[lightboxState] OPEN_LIGHTBOX';
export const CLOSE_LIGHTBOX: string = '[lightboxState] CLOSE_LIGHTBOX';
export const CHANGE_LIGHTBOX_INDEX: string =
  '[lightboxState] CHANGE_LIGHTBOX_INDEX';

// ----------------------------------------
//REVIEWS
// ----------------------------------------

export const ADD_REPLY: string = '[reviews] add reply';
export const ADD_REVIEW: string = '[reviews] add review';
export const FETCH_REVIEWS: string = '[reviews] fetch reviews';
export const DELETE_REPLY: string = '[reviews] delete reply';
export const DELETE_REVIEW: string = '[reviews] delete review';
export const STORE_REVIEWS: string = '[reviews] store reviews';
export const RESET_REVIEWS: string = '[reviews] reset reviews';
export const UPDATE_REPLY: string = '[reviews] update reply';
export const UPDATE_REVIEW: string = '[reviews] update review';
export const UPDATED: string = '[reviews] updated';

// ----------------------------------------
// RATINGS
// ----------------------------------------
export const SEND_RATINGS = '[ratings] send ratings';
export const FETCH_RATINGS = '[ratings] fetch ratings';
export const STORE_RATINGS = '[ratings] store ratings';
export const RESET_RATINGS = '[ratings] reset ratings';

//-----------------------------------------------
// ANALYTICS EVENT ACTION TYPES
// -----------------------------------------------
export const SET_USER_ID: string = '[ analytics event ]  SET_USER_ID';
export const ON_EMAIL_SUBSCRIPTION =
  '[ analytics event ] User Subscribed To Mailing List';
export const ON_FLIGHTS_SEARCH =
  '[ analytics event ] Track Search Params For adwords remarketing';
export const ON_FLIGHTS_BOOK_BUTTON_PRESS =
  '[ analytics event ] ON_FLIGHTS_BOOK_BUTTON_PRESS';
export const ON_FLIGHTS_REVIEW_VIEW =
  '[analytics event] ON_FLIGHTS_REVIEW_VIEW';
export const ACTIVATE_OPTIMIZE = '[analytics event] ACTIVATE_OPTIMIZE';
export const ON_PAYPAL_BUTTON_CLICK = '[analytics event] Track Paypal Pay Button Click';
export const ON_HG_CREDIT_APPLY_SUCCESS = '[analytics event] FLIGHTS - HG Credit Applyed Successfully';


// ADMIN ACTION
export const MASQUERADE_USER =
  '[ admin ] super user masquerade as another user';



// WEBPACK FOOTER //
// ./src/redux/actions/types.js